module.exports = __webpack_public_path__ + "img/SYNC.13d0a292.svg";